export default "__VITE_ASSET__DoVfeUdJ__"